<template>
  <div>
    <base-transaction-wrapper
      :name="this.transaction.description"
      :description="dateDescription"
      :date="dateFormatted"
      :price="amount | currency"
      :amountTotal="amountTotal"
      :status="status"
      :functionInformation="openDetails"
      :barPercent="transaction.cashback_process_progress"
    >
      <template #icon-transaction>
        <span class="icon c-base-transaction__icon-description">
          <base-icon width="24px" height="24px" :name="icon" />
        </span>
      </template>
      <template #icon-information>
        <span class="icon">
          <base-icon
            width="1.4em"
            height="1.4em"
            name="painel/chevron-left-icon"
          />
        </span>
      </template>
    </base-transaction-wrapper>

    <BaseTransactionDetails
      ref="transactionDetails"
      :icon="icon"
      :transaction="transaction"
      :discount="discount"
      :amountTotal="amountTotal"
      v-on:open-reference="openReferenceTransaction"
    />

    <BaseTransactionDetails
      v-if="transactionReference"
      ref="transactionReferenceDetails"
      :icon="icon"
      :transaction="transactionReference"
    />

    <BaseModalError
      ref="errorApi"
      v-if="errorApi"
      title="Não conseguimos encontrar"
      icon="error-api"
      :message="`<strong>Infelizmente não conseguimos<br />encontrar essa transação neste momento</strong>`"
    />
  </div>
</template>

<script>
import BaseTransactionWrapper from '@/components/Wallet/BaseTransactionWrapper.vue'
import BaseTransactionDetails from '@/components/Wallet/BaseTransactionDetails.vue'
import BaseModalError from '@/components/BaseModalError.vue'
import WalletApi from '@/lib/api/Wallet'

import TextHelper from '@/lib/utils/TextHelper'
import { format } from 'date-fns'

export default {
  props: {
    transaction: Object,
  },

  components: {
    BaseTransactionWrapper,
    BaseTransactionDetails,
    BaseModalError,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    icon() {
      const category = this.transaction.category.toUpperCase()

      if (category === 'GIFT') return 'painel/gift-icon'
      else if (category === 'CHARGEBACK') return 'painel/gift-chargeback-icon'
      else if (category === 'WITHDRAW') return 'painel/icon-transfer'
      else if (category === 'SHOPPING') return 'painel/shopping-icon'
      else if (category === 'CASHBACK') return 'painel/cashback-icon'
      else if (category === 'FUTURE_CASHBACK') return 'painel/cashback-icon'
      else if (category === 'REFUND') return 'painel/refund-icon'
      else if (category === 'REFUND_ORDER_ITEM')
        return 'painel/shopping-chargeback-icon'
      else if (category === 'PIX') return 'painel/pix-icon'
      else return 'painel/gift-icon'
    },

    amount() {
      const category = this.transaction.category.toUpperCase()
      let amount = this.transaction.amount
      if (
        category === 'WITHDRAW' ||
        category === 'CHARGEBACK' ||
        category === 'SHOPPING'
      )
        return -amount
      return amount
    },

    status() {
      let status
      if (this.transaction.type === 'debit') status = 'negative'
      else if (this.transaction.category === 'future_cashback')
        status = 'pending'
      else status = 'positive'

      return status
    },

    dateFormatted() {
      const textHelper = new TextHelper()
      let dateFormatted = textHelper.getFormattedDateString(
        this.transaction.created_at
      )

      if (this.transaction.category === 'future_cashback')
        dateFormatted = textHelper.getFormattedDateString(
          this.transaction.cashback_process_date
        )

      return new Date(dateFormatted)
    },

    dateDescription() {
      let textDescription =
        '<small>' +
        format(this.dateFormatted, '[Em] DD/MM/YYYY [às] HH:mm') +
        '</small>'

      if (this.transaction.category === 'future_cashback')
        textDescription =
          '<small> Faltam ' + this.calcDaysLeft() + ' para a liberação</small>'

      const description = textDescription

      return description
    },

    discount() {
      if (this.transaction.details && this.transaction.details.bonus_amount) {
        return this.transaction.details.bonus_amount
      }
      return 0
    },

    amountTotal() {
      if (
        this.transaction.details &&
        this.transaction.details.total_amount &&
        this.transaction.details.total_amount > this.transaction.amount
      ) {
        return this.transaction.details.total_amount
      }
      return 0
    },
  },

  data() {
    return {
      transactionReference: '',
      errorApi: false,
      leftDays: 0,
    }
  },

  methods: {
    openDetails() {
      this.$refs.transactionDetails.open()
    },
    openReferenceTransaction($id) {
      const walletApi = new WalletApi(this.logonToken)
      if (this.transactionReference) {
        return setTimeout(() => {
          this.$refs.transactionReferenceDetails.open()
        }, 500)
      }
      walletApi
        .getTransaction($id)
        .then((response) => {
          this.transactionReference = response.data.data
          setTimeout(() => {
            this.$refs.transactionReferenceDetails.open()
          }, 500)
        })
        .catch(() => {
          this.errorApi = true
          setTimeout(() => {
            this.$refs.errorApi.open()
          }, 500)
        })
    },

    calcDaysLeft() {
      let today = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      )
      today = Date.parse(today)

      let dateWillEarnCashback = new Date(
        this.transaction.cashback_process_date
      )

      dateWillEarnCashback = dateWillEarnCashback.setHours(0, 0, 0)

      const diffTime = Math.abs(dateWillEarnCashback - today)
      const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      return (this.leftDays = days == 1 ? days + ' dia ' : days + ' dias ')
    },
  },
}
</script>

<style lang="scss">
.c-base-transaction {
  margin-bottom: 12px;

  &__icon-description {
    margin-right: 6px;
  }
}
</style>
